import Highcharts from "highcharts/highcharts";
import ViewController from "core/views/view.controller";
import {Colors} from "main/main.config";

export default class ChartBookingWorkloadCtrl extends ViewController {
    static $inject = ['$scope'];

    constructor() {
        super(...arguments);

        this.chart = null;

        // Bindings
        this.workload = [];
    }

    $onInit() {
        if (!this.chart) {
            this.createChart();
        }
    }

    $onChanges(changes) {
        if (!changes.workload) {
            return;
        }

        if (!this.chart) {
            this.createChart();
        }

        this.updateChart();
    }

    createChart() {
        this.chart = Highcharts.chart('chart-booking-workload-hs', {
            chart: {
                type: 'pie',
                plotBackgroundColor: null,
                plotBorderWidth: 0,
                plotShadow: false,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 0,
                spacingRight: 0,
            },

            title: {
                text: '',
                align: 'center',
                verticalAlign: 'middle',
                y: 5,
                style: {
                    color: Colors.textNormal,
                    fontSize: "18px",
                    fontWeight: '300',
                    fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif'
                }
            },

            tooltip: {
                enabled: false
            },

            plotOptions: {
                pie: {
                    shadow: false,
                    center: ['50%', '50%'],
                    dataLabels: {
                        enabled: false
                    }
                },

                series: {
                    enableMouseTracking: false
                }
            },

            series: [{
                innerSize: '60%',
                data: this.createData(0)
            }]
        });
    }

    updateChart() {
        let workloadPercentage = this.workload ? this.workload.percentage : 0;
        this.chart.setTitle({text: workloadPercentage + '%'}, null, true);
        this.chart.series[0].setData(this.createData(workloadPercentage));
        this.chart.setSize(null, null, false);
    }

    createData(workloadPercentage) {
        return [{
            name: 'Finshed',
            y: workloadPercentage,
            color: Colors.highlight1
        }, {
            name: 'Open',
            y: 100 - workloadPercentage,
            color: Colors.bg
        }]
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-booking-workload/chart-booking-workload.controller.js